export type { PluginCommandRegistryInterface } from "./PluginCommandRegistry";
export { PluginCommandRegistry } from "./PluginCommandRegistry";
export { PluginExtensionRegistry } from "./PluginExtensionRegistry";
export { PluginLocaleRegistry } from "./PluginLocaleRegistry";
export { PluginMenuRegistry } from "./PluginMenuRegistry";
